export default __webpack_public_path__ + "static/media/image-8.2a4c7a6f.webp";